const Happy = [
    {id: "0", value: "極度悲觀價以下"},    
    {id: "1", value: "極度悲觀價 ~ 過度悲觀價"},
    {id: "2", value: "過度悲觀價 ~ 合理價"}, 
    {id: "3", value: "合理價 ~ 過度樂觀價"}, 
    {id: "4", value: "過度樂觀價 ~ 極度樂觀價"},
    {id: "5", value: "極度樂觀價以上"},        
  ];  
  
  export default Happy